<audio id="player" autoplay class="video-js vjs-default-skin vjs-nofull image-media" controls>
  <source type="audio/mp3" [src]="src">
</audio>
